import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Desktop Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-8">
          <div className="flex items-end justify-between">
            {/* Left Menu */}
            <div className="hidden lg:flex items-center space-x-8 mb-4">
              <button
                onClick={() => {
                  const heroSection = document.querySelector('section');
                  heroSection?.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`text-sm uppercase tracking-wider hover:opacity-70 transition-opacity whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-800' : 'text-white'
                }`}
              >
                home
              </button>
              {/* Portfolio Link */}
              <button
                className={`text-sm uppercase tracking-wider hover:opacity-70 transition-opacity whitespace-nowrap ${
                  isScrolled ? 'text-gray-800' : 'text-white'
                }`}
                onClick={() => {
                  const portfolioSection = document.querySelector('.portfolio-section');
                  if (portfolioSection) {
                    portfolioSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
              >
                portfolio
              </button>
              <button
                className={`text-sm uppercase tracking-wider hover:opacity-70 transition-opacity whitespace-nowrap ${
                  isScrolled ? 'text-gray-800' : 'text-white'
                }`}
                onClick={() => {
                  const contactSection = document.querySelector('#contact-section');
                  if (contactSection) {
                    contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
              >
                contact
              </button>
            </div>

            {/* Logo */}
            <Link to="/" className="flex-shrink-0">
              <img
                src={
                  isScrolled
                    ? 'https://static.readdy.ai/image/88800be73431afcf1237f8975cc2c2ab/216879551e8d78258aa6be4041d70126.png'
                    : 'https://static.readdy.ai/image/88800be73431afcf1237f8975cc2c2ab/216879551e8d78258aa6be4041d70126.png'
                }
                alt="Vivid Symphony"
                className="h-40 w-auto"
              />
            </Link>

            {/* Right Menu */}
            <div className="hidden lg:flex items-center space-x-8 mb-4">
              <button
                className={`text-sm uppercase tracking-wider hover:opacity-70 transition-opacity whitespace-nowrap ${
                  isScrolled ? 'text-gray-800' : 'text-white'
                }`}
                onClick={() => {
                  const aboutSection = document.querySelector('#about-section');
                  if (aboutSection) {
                    aboutSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
              >
                about
              </button>
              <button
                className={`text-sm uppercase tracking-wider hover:opacity-70 transition-opacity whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-800' : 'text-white'
                }`}
                onClick={() => {
                  const offersSection = document.querySelector('#offers-section');
                  if (offersSection) {
                    offersSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
              >
                Our Offers
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden w-8 h-8 flex items-center justify-center"
              aria-label="Menu"
            >
              <i
                className={`ri-menu-line text-2xl ${
                  isScrolled ? 'text-gray-800' : 'text-white'
                }`}
              ></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden fixed inset-0 bg-white z-40 transform transition-transform duration-300 ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col items-center justify-center h-full space-y-8">
          <button
            onClick={() => {
              const heroSection = document.querySelector('section');
              heroSection?.scrollIntoView({ behavior: 'smooth' });
              setIsMobileMenuOpen(false);
            }}
            className="text-xl uppercase tracking-wider hover:opacity-70 transition-opacity cursor-pointer"
          >
            home
          </button>
          <button
            className="block text-sm uppercase tracking-wider text-gray-800 hover:opacity-70 whitespace-nowrap"
            onClick={() => {
              const portfolioSection = document.querySelector('.portfolio-section');
              if (portfolioSection) {
                portfolioSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
              setIsMobileMenuOpen(false);
            }}
          >
            portfolio
          </button>
          <button
            className="block text-sm uppercase tracking-wider text-gray-800 hover:opacity-70 whitespace-nowrap"
            onClick={() => {
              const contactSection = document.querySelector('#contact-section');
              if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
              setIsMobileMenuOpen(false);
            }}
          >
            contact
          </button>
          <button
            className="block text-sm uppercase tracking-wider text-gray-800 hover:opacity-70 whitespace-nowrap"
            onClick={() => {
              const aboutSection = document.querySelector('#about-section');
              if (aboutSection) {
                aboutSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
              setIsMobileMenuOpen(false);
            }}
          >
            about
          </button>
          <button
            className="block text-sm uppercase tracking-wider text-gray-800 hover:opacity-70 whitespace-nowrap cursor-pointer"
            onClick={() => {
              const offersSection = document.querySelector('#offers-section');
              if (offersSection) {
                offersSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
              setIsMobileMenuOpen(false);
            }}
          >
            Our Offers
          </button>
        </div>
      </div>
    </>
  );
}
